// extracted by mini-css-extract-plugin
export default {"root":"header_root__0ZLHH","accountWrap":"header_accountWrap__lmm4t"};